<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-else-if="!loading">
          <crud-list
            v-model="fornecedores"
            :headers="headers"
            :actions="actions"
            :show-expand="true"
            :permission="'list_fornecedor'"
            :slots="['item.telefones', 'item.cpf', 'item.nome', 'item.fazendaProdutores']"
            :sort-by="['codigo']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template
              v-if="$store.getters.hasPermission('inserir_fornecedor')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  class="text-none text-white"
                  block
                  color="primary"
                  title="Cadastrar nova empresa"
                  rounded
                  @click="$router.push({ path: 'fornecedores/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}:  ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td
                v-if="item.fazendaProdutores.length"
                :colspan="headers.length"
                style="padding-left: 30px; padding-top: 10px;"
              >
                <div style="max-height: 500px; overflow-y: auto;">
                  <div>
                    <v-simple-table
                      dense
                      class="mb-5"
                      style="border: 1px solid lightgrey;"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th
                              colspan="6"
                              class="black--text font-weight-black"
                            >
                              Produtores / Fazendas: {{ item.fazendaProdutores.length }} - Ativos: {{ item.fazendaProdutores.filter((e) => e.ativo === 1).length }}
                            </th>
                          </tr>
                          <tr>
                            <th>
                              Status
                            </th>
                            <th>
                              Fazenda
                            </th>
                            <th>
                              Matrícula
                            </th>
                            <th>Produtor</th>
                            <th>Unidade de negócio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="fazendaProdutor in item.fazendaProdutores"
                            :key="fazendaProdutor.id"
                          >
                            <td>
                              <v-chip
                                v-if="!fazendaProdutor.ativo"
                                color="red lighten-1"
                                class="mb-2 pl-4 pr-4 my-1"
                                x-small
                                text-color="white"
                              >
                                <b>Inativo</b>
                              </v-chip>
                              <v-chip
                                v-if="fazendaProdutor.ativo"
                                color="green lighten-2"
                                class="mb-2 pl-4 pr-4 my-1"
                                x-small
                                text-color="white"
                              >
                                <b>Ativo</b>
                              </v-chip>
                            </td>
                            <td>{{ fazendaProdutor.fazenda.pessoajuridica.razao_social ? `${fazendaProdutor.fazenda.pessoajuridica.razao_social}` : `${fazendaProdutor.fazenda.pessoajuridica.razao_social}` }}</td>
                            <td>{{ fazendaProdutor.cod_produtor_fornecedor }}</td>
                            <td>{{ fazendaProdutor.produtor?.pessoafisica?.nome ? fazendaProdutor.produtor.pessoafisica.nome : (fazendaProdutor.produtor.pessoajuridica? fazendaProdutor.produtor.pessoajuridica.razao_social : null) }}</td>
                            <td>{{ fazendaProdutor.fazenda?.unidade_negocio.pessoajuridica ? fazendaProdutor.fazenda.unidade_negocio.pessoajuridica.nome_fantasia : '' }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
              </td>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import FornecedoresStore, { BOOTSTRAP, INATIVAR_FORNECEDOR } from '@/store/modules/fornecedores'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: {
    },
    data () {
      return {
        actions: [
          {
            title: 'Editar empresa',
            color: 'info darken-3',
            click: item => this.getFornecedor(item),
            icon: 'mdi-pencil',
            permission: 'editar_fornecedor',
          },
          {
            title: 'Excluir empresa',
            color: 'red darken-3',
            click: item => this.INATIVAR_FORNECEDOR(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_fornecedor',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', sortable: false, groupable: false, floatingfilter: false, value: 'data-table-expand' },
          { text: '', value: 'actions', sortable: false, groupable: false, width: '40px' },
          { align: 'left', sortable: true, groupable: false, text: 'Código', value: 'codigo', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Razão Social/Nome', value: 'nome_razao_social', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'CNPJ/CPF', value: 'cpf_cnpj', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'RG', value: 'rg', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Email', value: 'email', width: 'auto', floatingfilter: true, report: true, styleReport: { cellWidth: 65 } },
          { align: 'left', sortable: false, groupable: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true, styleReport: { cellWidth: 30 }, styleXLSX: { type: 'telefone' } },
          { align: 'left', sortable: true, groupable: false, text: 'Logradouro', value: 'endereco.logradouro', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Número', value: 'endereco.numero', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Complemento', value: 'endereco.complemento', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Bairro', value: 'endereco.bairro', width: 'auto', floatingfilter: true },
          { align: 'left', sortable: true, groupable: true, text: 'Cidade', value: 'endereco.cidade.nome', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Estado', value: 'endereco.estado.sigla', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'CEP', value: 'endereco.cep', width: 'auto' },
        ],
      }
    },
    computed: {
      ...mapState('fornecedores', ['loading', 'fornecedores']),
      ...mapGetters(['hasPermission']),
    },
    async created () {
      if (!this.$store.hasModule('fornecedores')) { this.$store.registerModule('fornecedores', FornecedoresStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('fornecedores', [BOOTSTRAP, INATIVAR_FORNECEDOR]),
      getFornecedor ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/fornecedores/alterar`,
          query: { id },
        })
      },
    },
  }
</script>
